import i18n from "i18n"
export const DATE_FORMAT = "MM/DD/YYYY"

export const SEASON_TYPES = {
  ALL_YEAR: "all-year",
  SEASONAL: "seasonal"
}

export const DATE_PICKER_PROPS = {
  autoComplete: "new-password",
  autoFill: "off",
  "data-form-type": "date"
}

export const DAYS = [
  { value: "sunday", label: i18n.t("experiences.days.sun") },
  { value: "monday", label: i18n.t("experiences.days.mon") },
  { value: "tuesday", label: i18n.t("experiences.days.tue") },
  { value: "wednesday", label: i18n.t("experiences.days.wed") },
  { value: "thursday", label: i18n.t("experiences.days.thu") },
  { value: "friday", label: i18n.t("experiences.days.fri") },
  { value: "saturday", label: i18n.t("experiences.days.sat") }
]

export const PRICING_TYPES = {
  PER_PERSON: "charge_per_person",
  FLAT_RATE: "charge_flat_rate"
}

// AntD's `required: true` rule treats numeric 0 as a present value, letting a
// 0-duration booking option through validation. Use this validator instead.
export const durationRule = (t) => ({
  validator: (_rule, value) =>
    value ? Promise.resolve() : Promise.reject(new Error(t("form_validation.cannot_be_blank")))
})

// Flat-rate "Guests Included" must be 1..maxGuests. Its InputNumber has no min/max, because
// InputNumber silently drops out-of-range entries from the form; this rule names the problem instead.
export const guestsIncludedRangeRule = (t, maxGuests) => ({
  validator: (_rule, value) => {
    if (typeof value !== "number") return Promise.resolve()
    if (value < 1) return Promise.reject(new Error(t("experiences.pricing.private.guests_included_min_one")))
    if (typeof maxGuests === "number" && value > maxGuests) {
      return Promise.reject(new Error(t("experiences.scheduling.sections.length_and_rates.guests_included_max_error")))
    }
    return Promise.resolve()
  }
})

export const isGuestsIncludedInRange = (guestsIncluded, maxGuests) =>
  typeof guestsIncluded === "number" && typeof maxGuests === "number" && guestsIncluded >= 1 && guestsIncluded <= maxGuests

export const TRIP_PRICE = {
  DURATION: "trip_duration",
  BUFFER_TIME: "trip_buffer_time",
  PRICE_ADULT: "price_per_person",
  PRICE_CHILD: "price_per_child",
  PRICE_INFANT: "price_per_infant",
  PRICE_PASSENGER: "price_per_passenger",
  FLAT_RATE: "flat_rate",
  GUESTS_INCLUDED: "included_guests",
  ADULTS_ALLOWED: "adults_allowed",
  CHILDREN_ALLOWED: "children_allowed",
  INFANTS_ALLOWED: "infants_allowed",
  PASSENGERS_ALLOWED: "passengers_allowed",
  EXTRA_GUESTS_ALLOWED: "extra_guests_allowed",
}

// Multi-day pricing keeps its guest-type "allowed" flags under dedicated form keys.
// The plain children_allowed / adults_allowed names collide with trip-level fields on
// the shared wizard form (e.g. the Details "child friendly" radio is name="children_allowed"),
// so the price toggles must not reuse them — they're mapped back to the backend keys
// only when building the payload.
export const MULTI_DAY_PRICE_ALLOWED = {
  ADULTS: "md_price_adults_allowed",
  CHILDREN: "md_price_children_allowed",
  INFANTS: "md_price_infants_allowed",
  PASSENGERS: "md_price_passengers_allowed",
}
